import { FormInstance } from "antd";
import { Dispatch, JSX, ReactNode, SetStateAction } from "react";

export interface AppRouteType {
  name: string;
  path: string;
  auth?: boolean;
  roles?: number;
  isPublic?: boolean;
  noLayout?: boolean;
  noWrapper?: boolean;
  permissions?: Permissions[];
  element: JSX.Element;
  setting?: boolean;
}

export const TAG_TYPES = {
  USER: "USER",
  STAFF: "STAFF",
  TRANSPORT_ORDER: "TRANSPORT_ORDER",
  STATUS: "STATUS",
  CONTAINER: "CONTAINER",
  CUSTOMER: "CUSTOMER",
  DRIVER: "DRIVER",
  VEHICLE: "VEHICLE",
  PORT: "PORT",
  CONTRACT: "CONTRACT",
  DOCUMENT: "DOCUMENT",
  DEPENDENT: "DEPENDENT",
  NOTIFICATION: "NOTIFICATION",
  PAYROLL: "PAYROLL",
  // Add more as needed
} as const;
export interface StepLayoutProps {
  title: string;
  description?: string;
  steps: {
    step: number;
    label: string;
    subLabel?: string;
    buttonChild?: React.ReactNode;
  }[];
  activeStep: number;
  fileName: string;
  children: React.ReactNode;
}

export interface BaseRecord<T> {
  [key: string | number]: string | number | Date | boolean | null | undefined | React.ReactNode | T[] | T;
}

export interface SelectOption extends BaseRecord<unknown> {
  value: string | number;
  label: string;
}

export interface ParsedFilter {
  key: string;
  operator?: string;
  raw: string;
}

export type FilterRule =
  | 'eq'
  | 'neq'
  | 'gt'
  | 'gte'
  | 'lt'
  | 'lte'
  | 'like'
  | 'nlike'
  | 'in'
  | 'nin'
  | 'isnull'
  | 'isnotnull';

export interface RawFilterValue {
  rule: FilterRule;
  value?: string | number | (string | number)[];
}

export type FilterInput = Record<string, string | number | boolean | RawFilterValue>;

export interface CollapseCommonProps {
  title?: string | ReactNode;
  defaultActive?: boolean;
  positionIcon?: 'start' | 'end';
  collapseKey: string | number;
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'xl' | 'sm';
  hideExpandIcon?: boolean;
  disableCollapse?: boolean;
}

export interface CollapseContainerProps extends CollapseCommonProps {
  hideExpandIcon?: boolean;
  disableCollapse?: boolean;
  isEdit?: boolean;
  isTransportOrderCompleted?: boolean;
  onSave: Dispatch<SetStateAction<boolean | undefined>>;
  onOpen: Dispatch<SetStateAction<boolean | undefined>>;
  form: FormInstance;
  isNew?: boolean;
  handleRemoveContainer: () => void;
  index?: number;
}

export interface FormatResponse<T> {
  statusCode: number;
  message?: string;
  success: boolean;
  data: T;
}

export type Option = {
  label: string;
  value: string | number;
};
